import { type WorkflowAttributes } from './generated/WorkflowAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';

interface Workflow extends WorkflowAttributes {}

@model
class Workflow extends ApplicationModel {
  // Start auto-generated
  static typename: 'Workflow' = 'Workflow';
  get typename(): 'Workflow' {
    return 'Workflow';
  }

  static internalTypename: 'Workflow' = 'Workflow';
  get internalTypename(): 'Workflow' {
    return 'Workflow';
  }

  static fields = {
    builtIn: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    transitionsOnly: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    workflowKinds: attr.hasMany({ readable: true }),
    workflowStatuses: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  constructor(attributes, options = {}) {
    super(attributes, options);

    this.local = {
      sortedWorkflowStatuses: null,
    };
  }

  get sortedWorkflowStatuses() {
    if (!this.local.sortedWorkflowStatuses) {
      const workflowStatuses = this.workflowStatuses ?? [];
      this.local.sortedWorkflowStatuses = [...workflowStatuses].sort(
        (a, b) => a.position - b.position
      );
    }
    return this.local.sortedWorkflowStatuses;
  }

  addWorkflowStatus(status) {
    this.sortedWorkflowStatuses.push(status);
  }

  removeWorkflowStatus(status) {
    this.sortedWorkflowStatuses.splice(
      this.sortedWorkflowStatuses.indexOf(status),
      1
    );
  }

  insertWorkflowStatusAtIndex(status, index) {
    const a = this.sortedWorkflowStatuses;
    const oldIndex = a.indexOf(status);
    if (oldIndex >= 0) a.splice(oldIndex, 1);
    a.splice(Math.min(a.length, index), 0, status);
  }
}

export default Workflow;
